<div
  [ngClass]="{
    'comming-soon': layout === 'default',
    'comming-soon--fullgrid': layout === 'fullgrid',
    'comming-soon--small': layout === 'small',
  }"
>
  <hdi-icon class="icon" [size]="size" [iconName]="icon" [color]="color">
  </hdi-icon>
  <div class="content">
    <p class="content__headline" [innerHTML]="headline"></p>
    <p class="content__text" [innerHTML]="content"></p>
    <div class="content__buttons">
      <hdi-button
        *ngIf="hasButton && buttonLayout === ButtonType.TERTIARY"
        [label]="buttonLabel | capitalize"
        [type]="buttonLayout"
        [title]="title ?? ''"
        [hrefType]="hrefType ?? HrefType.ANGULAR_ROUTE"
        [href]="hrefType !== HrefType.OPEN_MODAL_VIDEO ? href : undefined"
        (click)="handleButtonClick()"
      ></hdi-button>
      <hdi-link
        *ngIf="(hasButton && buttonLayout !== ButtonType.TERTIARY) || showModal"
        [ngClass]="{ 'content__buttons__link--hide': showModal }"
        [label]="showModal ? '' : (buttonLabel | capitalize)"
        [type]="linkLayout"
        [href]="href ?? ''"
        [hrefType]="hrefType ?? HrefType.ANGULAR_ROUTE"
        [video]="video"
        [showModal]="showModal"
        [title]="title ?? ''"
        (closeModalTrigger)="closeModal($event)"
      ></hdi-link>
    </div>
  </div>
</div>
